import React, { createContext, useContext, useState } from "react";

const BookingContext = createContext({ open: false, setOpen: () => {} });

export const BookingProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  return (
    <BookingContext.Provider value={{ open, setOpen }}>
      {children}
    </BookingContext.Provider>
  );
};

export const useBooking = () => useContext(BookingContext);
